import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-24 px-4 bg-green relative overflow-hidden" data-id="element-320" data-mp="1d0cpnrg32dfu">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-321" data-mp="1rqk0bkzums5z"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-322" data-mp="1mtbcp4vxlvxc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-323" data-mp="z2foehqopiuu">
          <h2 className="text-2xl md:text-3xl text-cream-light mb-4 font-medium" data-id="element-324" data-mp="17zq2sbysto3z">
            Presentamos el sistema docente más completo para enseñar
            Industrialización de Alimentos en América Latina.
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold text-gold mb-6" data-id="element-325" data-mp="2fg5ws0ou6taa">
            Mega Pack Industrialización de Alimentos en el Aula
          </h3>
          <p className="text-lg md:text-xl text-cream mb-12 font-medium" data-id="element-326" data-mp="2bxti98r55u44">
            5 tomos · 5 bonos · Todo listo para usar desde hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 text-left mb-16" data-id="element-327" data-mp="2kwwzs8anu1gi">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-4 bg-green-dark p-8 rounded-2xl border border-green-light/30" data-id="element-328" data-mp="2pvqda0py5sgo">
            <div className="flex items-start gap-3" data-id="element-329" data-mp="26wm6yzpsicsp">
              <X className="text-terracota shrink-0 mt-1" size={20} data-id="element-330" data-mp="26xe2kaje0aiz" />
              <p className="text-cream-light" data-id="element-331" data-mp="19hrvizuvruus">
                No es teoría copiada de un manual europeo sin contexto.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-332" data-mp="1ee8hpoiirz58">
              <X className="text-terracota shrink-0 mt-1" size={20} data-id="element-333" data-mp="2hqfj9qoy24x2" />
              <p className="text-cream-light" data-id="element-334" data-mp="2cs5npezb52ax">
                No es una colección de archivos sueltos que tenés que ordenar
                vos.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-335" data-mp="2qlnad8naiv56">
              <X className="text-terracota shrink-0 mt-1" size={20} data-id="element-336" data-mp="2mj0cor3xug02" />
              <p className="text-cream-light" data-id="element-337" data-mp="1ys38k0idwmzd">
                No es material que tengas que adaptar entero para que funcione
                en tu país.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream p-8 rounded-2xl border border-gold/50 relative overflow-hidden" data-id="element-338" data-mp="27tkptm7j2upn">
            <h4 className="text-xl font-bold text-green mb-4" data-id="element-339" data-mp="3ebhmfnzscfod">
              Es un sistema. Un sistema para que puedas:
            </h4>
            <ul className="space-y-3" data-id="element-340" data-mp="3qrzav8y582ag">
              {[{
              title: 'Planificar',
              desc: 'con contenidos organizados de manera lógica y progresiva'
            }, {
              title: 'Enseñar',
              desc: 'con explicaciones técnicas claras y contextualizadas para América Latina'
            }, {
              title: 'Aplicar',
              desc: 'con actividades y prácticas de taller listas para usar'
            }, {
              title: 'Evaluar',
              desc: 'sin construir un solo examen desde cero'
            }, {
              title: 'Desarrollar proyectos',
              desc: 'con guías completas de proyectos productivos reales'
            }].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-341" data-mp="34kwm7416gj9o" data-mpi={i}>
                  <Check className="text-terracota shrink-0 mt-1" size={18} data-id="element-342" data-mp="34i20zaacauf7" />
                  <span className="text-ink text-sm" data-id="element-343" data-mp="30hi487tohstl">
                    <strong className="text-green" data-id="element-344" data-mp="2vj6v5zb7jmcf">{item.title}</strong> —{' '}
                    {item.desc}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-345" data-mp="3o72ocu1kiw4g">
          <p className="text-2xl font-serif font-bold text-cream-light mb-8" data-id="element-346" data-mp="39k9jyjtl7ar1">
            La promesa es simple: menos tiempo buscando.{' '}
            <span className="text-gold" data-id="element-347" data-mp="auslnqjllgcy">Más tiempo enseñando.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}